<script setup lang="ts">
import Filter from './icons/Filter.vue';

interface Props {
  activeFilterCount: number;
  isOpen: boolean;
}

defineProps<Props>();

defineEmits({
  click: () => true,
});
</script>

<template>
  <button
    class="fixed bottom-6 left-6 z-50 w-14 h-14 bg-white rounded-full shadow-lg flex items-center justify-center hover:scale-110 transition-transform focus:outline-none focus:ring-2 focus:ring-(--color-primary)"
    :class="{ 'ring-2 ring-(--color-primary)': isOpen }"
    :aria-label="`Filters (${activeFilterCount} active)`"
    @click="$emit('click')"
  >
    <Filter class="w-7 h-7 text-gray-700" />
    <span
      v-if="activeFilterCount > 0"
      class="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-bold"
    >
      {{ activeFilterCount > 9 ? '9+' : activeFilterCount }}
    </span>
  </button>
</template>
